class a {
  numeric(e) {
    return `/^[0-9]+(${e}?)([0-9]{0,2})?$/`;
  }
}
export {
  a as default
};
